import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { commonTexts } from 'i18n';
import Dialog from './ConfirmationDialog.styled';
import { DialogContent, DialogTitle, DialogActions } from '../Dialog';
import { ConfirmationDialogProps } from './interfaces';
import Loader from './Loader';

export default function ConfirmationDialog({
  onClose,
  onSubmit,
  content,
  title,
  submitText,
  cancelText,
  isSubmitting = false,
  submitDisabled = false,
  hideSubmitButton = false,
  cancelButtonVariant = 'outlined',
}: ConfirmationDialogProps) {
  return (
    <Dialog
      fullWidth
      open
      onClose={onClose}
      disableEscapeKeyDown={isSubmitting}
    >
      <DialogTitle onClose={onClose}>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant={cancelButtonVariant}
          data-testid="cancel-button"
        >
          {cancelText || <FormattedMessage {...commonTexts.cancel} />}
        </Button>
        {!hideSubmitButton && (
          <Button
            onClick={onSubmit}
            variant="contained"
            data-testid="delete-button"
            disabled={submitDisabled}
          >
            {submitText || <FormattedMessage {...commonTexts.delete} />}
          </Button>
        )}
      </DialogActions>
      {isSubmitting && <Loader />}
    </Dialog>
  );
}
